export default "__VITE_ASSET__Bn4t5pfq__"